/**
 * Format a date to mm/dd/yyyy format
 * @param date - Date object, date string, or timestamp
 * @returns Formatted date string in mm/dd/yyyy format
 */
export const formatDateMMDDYYYY = (date: Date | string | number): string => {
  const dateObj = typeof date === 'string' || typeof date === 'number' 
    ? new Date(date) 
    : date;
  
  if (isNaN(dateObj.getTime())) {
    return ''; // Return empty string for invalid dates
  }
  
  const month = String(dateObj.getMonth() + 1).padStart(2, '0');
  const day = String(dateObj.getDate()).padStart(2, '0');
  const year = dateObj.getFullYear();
  
  return `${month}/${day}/${year}`;
};

/**
 * US English, human-readable: "April 5, 2026" (not numeric-only).
 */
export const formatDateUSReadable = (date: Date | string | number): string => {
  const dateObj =
    typeof date === 'string' || typeof date === 'number' ? new Date(date) : date;

  if (isNaN(dateObj.getTime())) {
    return '';
  }

  return dateObj.toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });
};

/**
 * Convert a date string in mm/dd/yyyy format to YYYY-MM-DD format (for HTML5 date inputs)
 * @param dateString - Date string in mm/dd/yyyy format
 * @returns Date string in YYYY-MM-DD format
 */
export const convertMMDDYYYYToYYYYMMDD = (dateString: string): string => {
  if (!dateString) return '';
  
  const parts = dateString.split('/');
  if (parts.length !== 3) return '';
  
  const [month, day, year] = parts;
  return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
};

/**
 * Convert a date string in YYYY-MM-DD format (from HTML5 date inputs) to mm/dd/yyyy format
 * @param dateString - Date string in YYYY-MM-DD format
 * @returns Date string in mm/dd/yyyy format
 */
export const convertYYYYMMDDToMMDDYYYY = (dateString: string): string => {
  if (!dateString) return '';
  
  const parts = dateString.split('-');
  if (parts.length !== 3) return '';
  
  const [year, month, day] = parts;
  return `${month}/${day}/${year}`;
};

